import { Box,Text,Link } from "@chakra-ui/react";
import { useHistory } from "react-router-dom";

export default function ExamScheduleList({ schedules}) {
   const history = useHistory();
    return (
       <Box
                w='100%'
                px='1rem'
                mb='1rem'
                border='1px solid rgba(0, 0, 0, 0.1)'
                boxShadow='0px 4px 10px rgba(0, 0, 0, 0.1)'
                borderRadius='10px'
                backgroundColor='#ffffff'
            >
            {Object.keys(schedules).map((keyName, keyIndex) =>
                <Box
                        w='100%'
                        d='flex'
                        justifyContent='space-between'
                        alignItems='center'
                        py='1rem'
                        fontSize='15px'
                        color='#000000'
                        fontWeight='600'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        borderBottom='1px solid rgba(0, 0, 0, 0.05)'
                    >
                   
                        
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='14%' textAlign='center'  cursor='pointer' onClick={() => history.push("/reports/student/examschedules/" + schedules[keyName]['id'])}>{schedules[keyName].classes.name}</Text>  
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='14%' textAlign='center'  cursor='pointer' onClick={() => history.push("/reports/student/examschedules/" + schedules[keyName]['id'])}>{schedules[keyName].degrees.name}</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='14%' textAlign='center'>{schedules[keyName].specification.name}</Text>    
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='14%' textAlign='center'>{schedules[keyName]['date']}</Text>                
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='14%' textAlign='center'>{schedules[keyName]['time']}</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='14%' textAlign='center'>{schedules[keyName]['time_noon']}</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='14%' textAlign='center'><Link href={schedules[keyName]['question_paper_doc']} style={{ textDecoration: 'none' }} target='_blank'>Open</Link></Text>
                         </Box>
               ) }
            

          
        </Box>
    )
}
